import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureReferral } from '@/services/affiliates';

export default function AffiliateTracker() {
  const location = useLocation();
  useEffect(() => {
    const ref = new URLSearchParams(location.search).get('ref');
    if (ref) void captureReferral(ref.toLowerCase());
  }, [location.search]);
  return null;
}
